/**
 * Remove SSR-injected JSON-LD scripts (`data-apt-seo-jsonld="1"`) after the SPA
 * mounts equivalent client schemas — EventSlugPage gold pattern.
 * Call only when entity data is ready (`!loading && entity`).
 */
export function stripAptSeoJsonLd(): void {
  if (typeof document === 'undefined') return;
  document
    .querySelectorAll('script[type="application/ld+json"][data-apt-seo-jsonld="1"]')
    .forEach((el) => el.remove());
}
